import React, { useState, createContext, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const UtilContext = createContext();

const UtilProvider = ({ children }) => {
    const browserLanguage = navigator.language;
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [IP, setIP] = useState(null);
    const [loadingLocation, setLoadingLocation] = useState(true); // Estado de carga

    const { DetailUser } = useContext(AuthContext);

    const detalles = (() => {
        const userDetails = localStorage?.getItem('userDetails');
        try {
            return userDetails ? JSON.parse(userDetails) : null;
        } catch (error) {
            console.error("Error al parsear 'userDetails':", error);
            return null;
        }
    })();

    useEffect(() => {
        const getLocationAndIP = async () => {
            setLoadingLocation(true); // Comenzar carga
            let retries = 3;
            let lat = null, lon = null;

            const fetchIP = async () => {
                try {
                    const response = await fetch("https://api.ipify.org?format=json");
                    const data = await response.json();
                    return data.ip || null;
                } catch (error) {
                    console.error("Error al obtener la IP:", error);
                    return null;
                }
            };

            const getLocation = async () => {
                return new Promise((resolve, reject) => {
                    if ('geolocation' in navigator) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => resolve({
                                lat: position.coords.latitude,
                                lon: position.coords.longitude
                            }),
                            (error) => reject(error),
                            { timeout: 5000 }
                        );
                    } else {
                        reject(new Error("Geolocalización no soportada"));
                    }
                });
            };

            while (retries > 0 && (lat === null || lon === null)) {
                try {
                    const location = await getLocation();
                    if (location.lat && location.lon) {
                        lat = location.lat;
                        lon = location.lon;
                        break;
                    }
                } catch (error) {
                    retries--;
                    if (retries === 0) {
                        console.warn("No se pudo obtener la ubicación.");
                    }
                }
            }

            const ip = await fetchIP();

            setLatitude(lat);
            setLongitude(lon);
            setIP(ip);
            setLoadingLocation(false); // Terminar carga
        };

        getLocationAndIP();
    }, []);

    const [language, setLanguage] = useState(
        detalles === null
            ? browserLanguage.slice(0, 2)
            : detalles?.country_company_incorporation === "US" ? "en" : "es"
    );

    const value = {
        setLanguage,
        language,
        longitude,
        latitude,
        IP,
        loadingLocation, // Ahora puedes usar este estado en cualquier parte
    };

    return <UtilContext.Provider value={value}>{children}</UtilContext.Provider>;
};

export default UtilProvider;
